module.exports = __webpack_public_path__ + "img/zhaungsi.820abb75.png";